import { render, staticRenderFns } from "./contractDetailReceipt.vue?vue&type=template&id=701fb309&scoped=true"
import script from "./contractDetailReceipt.vue?vue&type=script&lang=js"
export * from "./contractDetailReceipt.vue?vue&type=script&lang=js"
import style0 from "./contractDetailReceipt.vue?vue&type=style&index=0&id=701fb309&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701fb309",
  null
  
)

export default component.exports